import React, { useState } from 'react';
import api from '../api';
import { useNavigate, Link } from 'react-router-dom'; 
import bg from '../assests/bg.jpg';

// Function to validate email
const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
};

// Function to validate phone number (basic validation)
const isValidPhoneNumber = (phone) => {
    const re = /^[0-9]{10}$/; 
    return re.test(phone);
};

const LoginPage = () => {
    const [formData, setFormData] = useState({
        user: '', // Corrected key name to match `user`
        password: '',
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate(); 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        
      
        if (!isValidEmail(formData.user) && !isValidPhoneNumber(formData.user)) {
            setError('Please enter a valid email address or phone number.');
            return;
        }

        try {
            const response = await api.post('/admin/login', formData);
            setSuccess('Login successful!');
            setError('');
            // Navigate to the desired page after successful login
            navigate('/dashboard');
        } catch (err) {
            setError('Login failed. Please try again.');
            setSuccess('');
        }
    };
    return (
        <div
            className="container-fluid d-flex align-items-center justify-content-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
            }}
        >
            <div className="row justify-content-center w-100">
                <div className="col-md-6 col-lg-4">
                    <div
                        className="p-4 rounded shadow-sm"
                        style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.8)', // Slightly opaque white background
                        }}
                    >
                        <h2 className="mb-4 text-center">LOGIN</h2>
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="form-group mb-3">
                                <label htmlFor="user">Email or Phone Number:</label>
                                <input
                                    type="text"
                                    id="user"
                                    name="user"
                                    className="form-control"
                                    value={formData.user}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="password">Password:</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-control"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="d-flex flex-column">
                                <button type="submit" className="btn btn-success mb-2">Login</button>
                                <Link
                                    to="/signup"
                                    style={{
                                        textAlign: 'center', 
                                        color: 'black', 
                                        display: 'block',
                                        marginTop: '10px', 
                                        textDecoration: 'none',
                                        fontSize: '16px', 
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Create Account
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
